import normal from './normal'
import navDark from './nav-dark'
import navLight from './nav-light'

export default {
  normal,
  'nav-dark': navDark,
  'nav-light': navLight
}
